(function (global) {
	const HEADER_NAMES = ['transcript', 'transcripts', 'text', 'message', 'voicemail'];

	const parseCsv = (text) => {
		const rows = [];
		let row = [];
		let field = '';
		let inQuotes = false;
		const source = String(text || '').replace(/^\uFEFF/, '');

		for (let i = 0; i < source.length; i += 1) {
			const char = source[i];
			const next = source[i + 1];

			if (inQuotes) {
				if (char === '"') {
					if (next === '"') {
						field += '"';
						i += 1;
					} else {
						inQuotes = false;
					}
				} else {
					field += char;
				}
			} else if (char === '"') {
				inQuotes = true;
			} else if (char === ',') {
				row.push(field);
				field = '';
			} else if (char === '\n') {
				row.push(field);
				rows.push(row);
				row = [];
				field = '';
			} else if (char !== '\r') {
				field += char;
			}
		}

		if (field.length || row.length) {
			row.push(field);
			rows.push(row);
		}

		return rows;
	};

	const parseCsvTranscripts = (text) => {
		const rows = parseCsv(text);
		if (!rows.length) return [];

		const header = rows[0].map((cell) => String(cell || '').trim().toLowerCase());
		const headerIndex = header.findIndex((name) => HEADER_NAMES.indexOf(name) !== -1);
		const start = headerIndex >= 0 ? 1 : 0;
		const column = headerIndex >= 0 ? headerIndex : 0;
		const items = [];

		for (let i = start; i < rows.length; i += 1) {
			const value = String((rows[i] && rows[i][column]) || '')
				.replace(/\s+/g, ' ')
				.trim();
			if (value) items.push(value);
		}

		return items;
	};

	const fetchTranscripts = (url) => {
		const href = String(url || '').trim();
		if (!href) return Promise.resolve([]);

		return fetch(href, { credentials: 'omit', mode: 'cors' }).then((response) => {
			if (!response.ok) {
				throw new Error('Failed to fetch transcripts CSV');
			}
			return response.text();
		}).then(parseCsvTranscripts);
	};

	const sample = (items, count) => {
		const list = Array.isArray(items) ? items.slice() : [];
		const size = Math.max(0, Math.min(list.length, parseInt(count, 10) || 0));

		for (let i = list.length - 1; i > 0; i -= 1) {
			const j = Math.floor(Math.random() * (i + 1));
			const swap = list[i];
			list[i] = list[j];
			list[j] = swap;
		}

		return list.slice(0, size);
	};

	const search = (items, query, limit) => {
		const list = Array.isArray(items) ? items : [];
		const needle = String(query || '').trim().toLowerCase();
		const max = Math.max(0, parseInt(limit, 10) || 0);

		if (!needle) {
			return { items: sample(list, max), total: list.length, query: '' };
		}

		const matches = [];
		for (let i = 0; i < list.length; i += 1) {
			if (String(list[i]).toLowerCase().indexOf(needle) !== -1) {
				matches.push(list[i]);
			}
		}

		return {
			items: matches.slice(0, max),
			total: matches.length,
			query: needle,
		};
	};

	global.TranscriptsData = {
		parseCsvTranscripts,
		fetchTranscripts,
		sample,
		search,
	};
})(window);
